export default "__VITE_ASSET__BzkpGebK__"